module.exports = __webpack_public_path__ + "img/2.Audi2017.f1fe88eb.png";